import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import SVG from 'react-inlinesvg'
import hexToRgba from 'hex-to-rgba'

const StyledLi = styled.li`
  background-color: #fff;
  border-left: 1px solid rgba(10, 22, 70, 0.1);
  box-shadow: 0 1px 0 0 rgba(10, 22, 70, 0.1);
  flex-basis: 0;
  flex-grow: 1;
  height: 156px;
  overflow: hidden;

  &:first-child {
    border-bottom-left-radius: 8px;
    border-left: 0;
    border-top-left-radius: 8px;
  }

  &:last-child {
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }
`

const StyledLink = styled(({ singleCategory, ...rest }) => <Link {...rest} />)`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;

  ${({ singleCategory }) =>
    singleCategory &&
    css`
      opacity: 0.5;
    `}

  ${({ current, singleCategory }) =>
    current &&
    css`
      opacity: 1;
    `}
`

const StyledCategoryName = styled.p`
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-top: 16px;
  text-transform: uppercase;
`

const StyledIcon = styled.div`
  align-items: center;
  background-color: ${({ color, opacity }) => hexToRgba(color, opacity)};
  border-radius: 50%;
  display: flex;
  height: 64px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 64px;

  ${StyledLink}:hover & {
    svg {
      path {
        stroke: #fff;
      }
      circle {
        stroke: #fff;
      }
    }
  }
`

const StyledSVG = styled(SVG)`
  z-index: 2;
`

const StyledCircle = styled.span`
  background-color: ${({ color }) => color};
  border-radius: 50%;
  display: block;
  height: 64px;
  position: absolute;
  transform: scale(0);
  transition: transform 250ms;
  width: 64px;

  ${StyledLink}:hover & {
    transform: scale(1);
    transition: transform 250ms;
  }
`

const SingleBlogCategoryItem = ({ data = {}, current, singleCategory }) => (
  <StyledLi>
    <StyledLink
      singleCategory={singleCategory}
      current={current ? 'true' : undefined}
      to={`/blog/category/${data.slug}`}
    >
      {data.color && data.icon ? (
        <StyledIcon color={data.color} opacity={data.colorOpacity}>
          <StyledCircle color={data.color} />
          <StyledSVG cacheGetRequests={true} src={data.icon.file.url} />
        </StyledIcon>
      ) : (
        <div>{data.name}: Missing Icon, Color, or Color Opacity</div>
      )}
      <StyledCategoryName>{data.name}</StyledCategoryName>
    </StyledLink>
  </StyledLi>
)

export default SingleBlogCategoryItem
